import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function SimilarProducts({ productId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const scroller = useRef(null);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    api.get(`/products/${productId}/similar?limit=12`)
      .then((r) => { if (alive) setItems(r.data || []); })
      .catch(() => { if (alive) setItems([]); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [productId]);

  const scrollBy = (dir) => {
    scroller.current?.scrollBy({ left: dir * 320, behavior: "smooth" });
  };

  if (loading || items.length === 0) return null;

  return (
    <section className="mt-16" data-testid="similar-products">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-display text-lg md:text-xl text-foreground flex items-center gap-2">
          <Sparkles size={18} className="text-gold" /> Benzer Modeller
        </h2>
        <div className="hidden sm:flex gap-2">
          <button data-testid="similar-prev" onClick={() => scrollBy(-1)} className="p-2 rounded-md border border-border hover:border-gold hover:text-gold transition-colors">
            <ChevronLeft size={16} />
          </button>
          <button data-testid="similar-next" onClick={() => scrollBy(1)} className="p-2 rounded-md border border-border hover:border-gold hover:text-gold transition-colors">
            <ChevronRight size={16} />
          </button>
        </div>
      </div>
      <div ref={scroller} className="flex gap-4 overflow-x-auto pb-2 scroll-smooth snap-x" style={{ scrollbarWidth: "thin" }}>
        {items.map((p, i) => (
          <div key={p.id} className="shrink-0 w-44 sm:w-48 snap-start">
            <ProductCard product={p} index={i} />
          </div>
        ))}
      </div>
    </section>
  );
}
